import { AIScribeContainer } from "@/AIScribe/Components/AIScribeContainer";
import { IAIScribeContainerModel } from "@/AIScribe/Models/IAIScribeContainerModel";
import { ExternalBillingCredentialsPopup } from "@/Billing/Components/ExternalBilling/ExternalBillingCredentialsPopup";
import { ExternalBillingEmployeeSelectPopup } from "@/Billing/Components/ExternalBilling/ExternalBillingEmployeeSelectPopup";
import { FacturationNetCredentialsPopup } from "@/Billing/Components/FacturationNet/FacturationNetCredentialsPopup";
import { Client } from "@/Common/Api/Client";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { ExternalBillingUserInfoDto } from "@/Common/Api/ExternalBilling/Dto/ExternalBillingUserInfoDto";
import { BaseReactComponent, EmptyProps } from "@/Common/Components/BaseReactComponent";
import { CallCenterMain } from "@/Common/Components/CallCenter/CallCenterMain";
import { ClickableTextEditor } from "@/Common/Components/ClickableText/ClickableTextEditor";
import { DSQEmployeeComponent } from "@/Common/Components/DSQ/DSQEmployeeComponent";
import { DSQImgsGridComponent } from "@/Common/Components/DSQ/DSQImgsGridComponent";
import { DSQLabsGridComponent } from "@/Common/Components/DSQ/DSQLabsGridComponent";
import { DSQNipComponent } from "@/Common/Components/DSQ/DSQNipComponent";
import { DSQPatientComponent } from "@/Common/Components/DSQ/DSQPatientComponent";
import { TimerComponent } from "@/Common/Components/Inputs/TimerComponent";
import { AsyncLoaderControl } from "@/Common/Components/Loader/AsyncLoaderControl";
import { CommonErrorComponent } from "@/Common/Components/Modals/CommonPopupComponent";
import { Popup } from "@/Common/Components/Modals/Popup";
import { MyleMenu } from "@/Common/Components/MyleMenu/MyleMenu";
import { PortalPatientSync } from "@/Common/Components/Portal/PortalSync/PortalPatientSync";
import { PersonSearchAutocompleteCustom } from "@/Common/Components/Search/PersonSearchAutocompleteCustom";
import { Sidebar } from "@/Common/Components/Sidebar/Sidebar";
import { SidebarExpandedSearch } from "@/Common/Components/Sidebar/SidebarExpandedSearch";
import { SignatureOptionPopup } from "@/Common/Components/Sign/SignatureOptionPopup";
import { TelemedApplicationPopup } from "@/Common/Components/Telemed/TelemedApplicationPopup";
import { Toast } from "@/Common/Components/Toast/Toast";
import { TermsAndConditionsPopup } from "@/Common/Components/User/TermsAndConditionsPopup";
import { OpenAttachmentsPopupItem } from "@/Common/Models/Attachments/OpenAttachmentsPopupItem";
import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";
import { FileSelectionContainerType } from "@/Common/Models/FileSelection/FileSelectionContainerType";
import { Guid } from "@/Common/Models/Guid";
import { MyleTabKey } from "@/Common/Models/MyleMenu/enums/MyleTabKey";
import { MyleMenuTabItem } from "@/Common/Models/MyleMenu/MyleMenuTabItem";
import { Patient } from "@/Common/Models/Patient/Patient";
import { PossiblePatientWarning } from "@/Common/Models/Patient/PatientEnums";
import { PatientPossibleWarningDto } from "@/Common/Models/Patient/PatientPossibleWarningDto";
import { Person } from "@/Common/Models/Person/Person";
import { MessageOrTaskContext } from "@/Common/Models/UI/Enums";
import { ILoginModel } from "@/Common/Models/UI/Login/ILoginModel";
import { PopupModel } from "@/Common/Models/UI/PopupModel";
import { ISidebarModel } from "@/Common/Models/UI/Sidebar/ISidebarModel";
import { ModulesProvider } from "@/Common/Modularity/Components/ModulesProvider";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { TermsAndConditionsServiceNames } from "@/Common/Resources/Lookups/Enums/TermsAndConditionsServiceNames";
import { BillingProvider } from "@/Common/Services/ExternalBilling/BillingProvider";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { MessageTaskEditContainer } from "@/Communications/Components/MessageTaskEdit/MessageTaskEditContainer";
import { SendRecallPopupControl } from "@/Communications/Components/Recalls/SendRecallPopupControl";
import { ISendRecallPopupModel } from "@/Communications/Models/UI/IRecallPopupModel";
import { ISendTaskOrMessagePopupModel } from "@/Communications/Models/UI/ITaskMessagePopupModel";
import { OpenAttachmentsPopup } from "@/Documents/Components/Attachments/OpenAttachmentsPopup";
import { FaxSignPrintExportableFileComponent } from "@/ExportableFile/Components/FaxSignPrintExportableFileComponent";
import { FileSelectionContainer } from "@/ExportableFile/Components/FileSelection/FileSelectionContainer";
import { IFaxCoverSheetProps } from "@/ExportableFile/Components/IFaxInformationProps";
import { ExportableFile } from "@/ExportableFile/Models/ExportableFile";
import { IFaxPrintExportableFileConfig } from "@/ExportableFile/Models/IFaxPrintExportableFileConfig";
import { ILabsTabModel } from "@/Labs/Models/UI/ILabsTabModel";
import { ApexExternalSearchPopup } from "@/Patient/Components/ApexExternalSearchPopup";
import { DSQActiveMedGridComponent } from "@/Patient/Components/DSQ/DSQActiveMedGridComponent";
import { OpenPatientsDropdown } from "@/Patient/Components/OpenPatientsDropdown";
import { PatientMissingInfoWarning } from "@/Patient/Components/PatientMissingInfoWarning";
import { ExternalSearchComponent } from "@/Patient/Components/Search/ExternalSearch/ExternalSearchComponent";
import { HealthCardScanner } from "@/Patient/Components/Search/HealthCardScanner/HealthCardScanner";
import { IAPSSInboxModel } from "@/Portfolio/Models/UI/IAPSSInboxModel";
import { fetchPrescriptionsRenewalCounters } from "@/PrescriptionRenewals/Api/PrescriptionRenewalsClient";
import { SessionTimeoutWarningPopup } from "./Main/SessionTimeoutWarningPopup";
import { VisitTypeSelectionPopup } from "./VisitTypeSelectionPopup";

class MainState {
    public LabsTabModel: ILabsTabModel;
    public SidebarModel: ISidebarModel;
    public SendTaskOrMessagePopupModel?: ISendTaskOrMessagePopupModel;
    public SendRecallPopupModel?: ISendRecallPopupModel;
    public LoginModel: ILoginModel;

    public ApssInboxModel: IAPSSInboxModel;
    public Tabs: MyleMenuTabItem[];
    public PatientDropdownVisible: boolean;
    public ClickableTextCreateVisible: boolean;
    public ClickableTextContext: string;
    public ClickableTextEditMode: boolean;
    public ClickableTextTabName: string;
    public IsPatientStoreLoadingStuff: boolean;
    public SelectedPortalPatient: Person;
    public DisplayPortalSyncModal: boolean;

    public showVisitTypeSelectionPopup: boolean;
    public visitTypeSelectionPopupCallback: () => void;

    public CommonPopupModel: PopupModel;

    public DisplayExternalSearch: boolean;
    public DisplayExternalSearchCallBack: () => void;
    public DisplayApexExternalSearchPopup: boolean;
    public DisplayApexExternalSearchPopupPerson: Person;

    public PatientIdentifier: string;
    public ExternalSearchPatientContactId: string;
    public ExternalSearchSiteId: Guid;
    public DisplayDSQNipPopup: boolean;
    public DisplayDSQPatientPopup: boolean;
    public PatientModelForDSQ: Patient;
    public DisplayDSQActiveMedPopup: boolean;
    public DisplayDSQLabsGridPopup: boolean;
    public DisplayDSQImgsGridPopup: boolean;

    public DisplayAttachmentPopup: boolean;
    public AttachmentPopupPatientPerson: Person;
    public AttachmentPopupPatientSearch: string;
    public AttachmentPopupResponseCallback: (attachments: ExportableFile[]) => void;
    public AttachmentPopupMaxFiles: number;

    public DisplaySessionExpiryWarning: boolean;

    public PatientContactId: string;
    public DSQFunction: () => void;
    public DSQEmployeePopup: boolean;

    public OpenAttachmentsPopup: boolean;
    public OpenAttachmentsPopupItems: OpenAttachmentsPopupItem[];
    public OpenAttachmentsPopup_Xpos: number;
    public OpenAttachmentsPopup_Ypos: number;

    public employeeId: string;
    public adminMode: boolean;
    public enumAdminMode: number;
    public isFromAnotherUser: boolean;
    public employeeGroupId: string;
    public isGroupMode: boolean;
    public clickableContent: string;
    public isAdminCreateMode: boolean;
    public languageCode: string;

    public displayFacturationNetCredentialsPopup: boolean;
    public facturationNetResponse: ServerEvent;

    public isFaxPrintSignPopupOpen: boolean;
    public faxPrintConfig: IFaxPrintExportableFileConfig;

    public hasOverlay: boolean;
    public overlaysHaveBackground: boolean;
    public overlaysHaveZIndexAbovePopup: boolean;

    public telemedApplicationUrl: string;

    public faxCoverSheetProps: IFaxCoverSheetProps;

    public aiScribeContainerModel: IAIScribeContainerModel;

    public patientWarningsPopup: {
        patientContactId: string;
        isOpen: boolean;
        warnings: PossiblePatientWarning[];
        callback: (dto: PatientPossibleWarningDto) => void;
    };

    public popups: { [key: string]: JSX.Element };

    public externalBillingAuthPopup: {
        isOpen: boolean;
        billingProvider: BillingProvider;
        billingUser?: ExternalBillingUserInfoDto;
        onAuthSuccess?: (billingUser: ExternalBillingUserInfoDto) => void;
    };

    public TermsAndConditionsPopup: {
        isOpen: boolean;
        serviceName?: TermsAndConditionsServiceNames;
        onOk?: () => void;
    };

    public signatureOptionPopup: {
        isOpen: boolean;
        onSaveSuccess: (pin: string) => void;
    };

    public externalBillingEmployeeSelectPopup: {
        isOpen: boolean;
        encounterEmployeeIds?: string[];
        otherEmployeeIds?: string[];
        primaryClinicians?: string[],
        onEmployeeSelect?: (employeeId: string) => void;
    };

    constructor(init?: Partial<MainState>) {
        Object.assign(this, init);
    }
}

class Main extends BaseReactComponent<EmptyProps, MainState> {
    constructor(props: EmptyProps) {
        super(props);

        const initialState = new MainState();
        initialState.LoginModel = sessionStore.clientLoginModel;

        initialState.Tabs = cacheStore.Tabs;
        initialState.SendTaskOrMessagePopupModel = globalSendCommunicationStore?.SendTaskOrMessageModel;
        initialState.SendRecallPopupModel = globalSendCommunicationStore?.SendRecallPopupModel;
        initialState.TermsAndConditionsPopup = {
            isOpen: false
        };
        initialState.SidebarModel = sidebarStore.Model;
        initialState.LabsTabModel = labsStore.Model;
        initialState.IsPatientStoreLoadingStuff = false;
        initialState.DisplayPortalSyncModal = false;
        initialState.CommonPopupModel = null;
        initialState.DisplaySessionExpiryWarning = false;
        initialState.telemedApplicationUrl = "";
        initialState.externalBillingAuthPopup = {
            isOpen: false,
            billingProvider: BillingProvider.ClinicDefault
        };
        initialState.externalBillingEmployeeSelectPopup = {
            isOpen: false
        };
        initialState.popups = {};
        initialState.signatureOptionPopup = {
            isOpen: false,
            onSaveSuccess: () => null
        };
        initialState.faxCoverSheetProps = {};

        initialState.aiScribeContainerModel = aiScribeStore.Model;

        this.state = initialState;
    }

    private eventIds = {
        navStoreId: "",
        sessionStoreId: "",
        overlayStoreId: "",
        cacheStoreId: "",
        globalcommStoreId: "",
        communicationsStoreId: "",
        sidebarStore: "",
        patientStore: "",
        labsStore: "",
        ramqStore: "",
        portfolioStore: "",
        prescriptionRenewalsStore: "",
        pharmacyOrdersStore: "",
        aiScribeStore: ""
    };

    private localDispatcherReferenceId: string;

    private defaultTabs: Record<string, string> = cacheStore.Tabs?.reduce((prev, current) => ({
        ...prev,
        [current.key]: current.path
    }), {}) ?? {};

    private unlistenRouteChange: () => void;

    public componentWillUnmount(): void {
        navStore.RemoveChangeListener(this.eventIds.navStoreId);
        sessionStore.RemoveChangeListener(this.eventIds.sessionStoreId);
        cacheStore.RemoveChangeListener(this.eventIds.cacheStoreId);
        globalSendCommunicationStore.RemoveChangeListener(this.eventIds.globalcommStoreId);
        communicationsStore.RemoveChangeListener(this.eventIds.communicationsStoreId);
        sidebarStore.RemoveChangeListener(this.eventIds.sidebarStore);
        patientStore.RemoveChangeListener(this.eventIds.patientStore);
        labsStore.RemoveChangeListener(this.eventIds.labsStore);
        ramqStore.RemoveChangeListener(this.eventIds.ramqStore);
        portfolioStore.RemoveChangeListener(this.eventIds.portfolioStore);
        prescriptionRenewalsStore.RemoveChangeListener(this.eventIds.prescriptionRenewalsStore);
        pharmacyOrdersStore.RemoveChangeListener(this.eventIds.pharmacyOrdersStore);
        aiScribeStore.RemoveChangeListener(this.eventIds.aiScribeStore);
        MainComponentStateDispatcher.unregister(this.localDispatcherReferenceId);
        this.unlistenRouteChange();

        super.componentWillUnmount();
    }

    public shouldComponentUpdate(): boolean {
        return true;
    }

    public render(): JSX.Element {
        let globalOverlayCssClass = "";
        if (this.state.hasOverlay) {
            globalOverlayCssClass = "global-overlay";

            if (this.state.overlaysHaveBackground)
                globalOverlayCssClass += " translucent";

            if (this.state.ClickableTextCreateVisible === true)
                globalOverlayCssClass += " zidxpp";

            if (this.state.overlaysHaveZIndexAbovePopup)
                globalOverlayCssClass += " zindexAbovePopup";
        }

        var sidebarCss = "transition closed";
        var open = this.state.SidebarModel.get("IsOpen");

        if (open) { sidebarCss = "transition"; }

        if (open && this.state.SidebarModel.get("IsAdvancedSearchView") || (open && this.state.SidebarModel.get("IsCreateMode"))) {
            sidebarCss = "transition advanced";
        }

        return (
            <ModulesProvider>
                <div onClick={() => this.closeOpenPatientDropdownIfOpen()} style={{ minWidth: "300px" }}>
                    <div onClick={e => this.onContainerClick(e)} className={globalOverlayCssClass} data-cy="main-globalOverlay">
                        {globalOverlayCssClass != null && globalOverlayCssClass.length > 0 && (
                            <div className="exitOverlay" onClick={() => overlayStore.hideAllOverlays()}>
                                X
                            </div>
                        )}
                    </div>
                    <HealthCardScanner />

                    {this.renderPopups()}

                    <div className="global-container" onClick={() => this.onUserInput()} onKeyPress={() => this.onUserInput()}>
                        <header>
                            <div className="flex-container pointer" style={{ float: "right" }}>
                                {sessionStore.getCurrentEmployee().DisableTimers != true && sessionStore.timerComponentModel != null && (
                                    <div className="flex-container" style={{ visibility: "hidden", flexDirection: "column", justifyContent: "center", height: "50px", marginRight: "9px" }}>
                                        <TimerComponent
                                            format="(HH:mm:ss)"
                                            model={sessionStore.timerComponentModel}
                                            saveCallback={(model, value) => {
                                                if (sessionStore.timerComponentModel != null) { // timerComponentModel is still on our Encounter client side (This callback is delayed a little)
                                                // If Match CurrentSession Timer
                                                    if (model.encounterId == sessionStore.timerComponentModel.encounterId)
                                                        sessionStore.timerCurrentValue = value;

                                                    // If match Current Note EncounterId
                                                    let noteModel = patientStore.PatientMedicalNoteModels[model.patientContactId];
                                                    if (noteModel != null) {
                                                        let encounter = noteModel.get("Encounter");
                                                        if (encounter.Id == model.encounterId) {
                                                            encounter.EncounterRelatedEmployees = encounter.EncounterRelatedEmployees.map(rel => {
                                                                if (rel.EmployeeId == sessionStore.getCurrentEmployee().ContactFacetId)
                                                                    rel.DurationTicks = value.ticks.toString();
                                                                return rel;
                                                            });
                                                            noteModel = noteModel.set("Encounter", encounter);
                                                        // Do not emit changes, people might be typing stuff in the note, we dont want to interfeer with them.
                                                        }
                                                    }
                                                }

                                                // Always Save
                                                Client.Post(ServerOperations.Server.Myle_SaveEncounterTimeSpent, {
                                                    EmployeeId: sessionStore.getCurrentEmployee().ContactFacetId,
                                                    EncounterId: model.encounterId,
                                                    Ticks: value.ticks
                                                }, () => null);
                                            }}
                                            saveIntervalSeconds={60}
                                        />
                                    </div>
                                )}
                                <div className="user-context-icon" onClick={() => this.togglePeopleDropdown()} />
                            </div>
                            <MyleMenu Tabs={this.state.Tabs} />
                            {this.state.PatientDropdownVisible
                            && <OpenPatientsDropdown onSelectCallback={() => this.onPersonFileSelection()} />
                            }
                        </header>

                        <div className="main-container">
                            <aside className={sidebarCss}>
                                <div className="hide-overflow clearfix">
                                    {this.state.SidebarModel.get("IsAdvancedSearchView") === false && <Sidebar Model={this.state.SidebarModel} CalendarControlId="sidebarCalendar" SearchResultClickDisabled={this.state.IsPatientStoreLoadingStuff} />}
                                    {this.state.SidebarModel.get("IsAdvancedSearchView") && (
                                        <SidebarExpandedSearch
                                            Model={this.state.SidebarModel}
                                            SearchResultClickDisabled={this.state.IsPatientStoreLoadingStuff}
                                        />
                                    )}
                                </div>
                            </aside>
                            <div className="aside-handle" onClick={e => this.toggleAside(e)}>
                                <div onClick={e => this.toggleAside(e)} className="slide-menu-icon blue">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </div>

                            {(this.props.children)}
                        </div>
                        {cacheStore.ClinicSettings.IsCallCenterEnabled() && (
                            <CallCenterMain />
                        )}
                        {cacheStore.ClinicSettings.EnableAIScribe && this.state.aiScribeContainerModel && (
                            <AIScribeContainer
                                model={this.state.aiScribeContainerModel}
                            />
                        )}
                        <Toast />
                        <AsyncLoaderControl IsActive={sessionStore.loading} />
                    </div>

                </div>
            </ModulesProvider>
        );
    }

    public renderPopups(): JSX.Element {
        const employee = sessionStore.getCurrentEmployee();
        const taskEditSelectedClinicians = sessionStore.prefillTaskSelectedClinicians ?? [];
        const messageEditSelectedClinicians = sessionStore.prefillMessageSelectedClinicians ?? [];

        return (
            <div>
                {this.state.CommonPopupModel && (
                    <CommonErrorComponent
                        id="commonPopupComponent"
                        model={this.state.CommonPopupModel}
                        onCloseCallback={() => this.setPopupModel(null)}
                    />
                )}

                {this.state.showVisitTypeSelectionPopup == true && (
                    <VisitTypeSelectionPopup
                        value={sessionStore.isScheduledVisitChecked}
                        onChange={isScheduledVisitChecked => {
                            sessionStore.isScheduledVisitChecked = isScheduledVisitChecked;
                            this.mutateState(s => s.showVisitTypeSelectionPopup = false, this.state.visitTypeSelectionPopupCallback);
                        }}
                        onClose={() => this.mutateState(s => s.showVisitTypeSelectionPopup = false)}
                    />
                )}

                {this.state.DisplayPortalSyncModal && (
                    <PortalPatientSync
                        componentId="portalSyncPopup"
                        person={this.state.SelectedPortalPatient}
                        onCancelCallback={() => this.closeSyncModal()}
                        initialSearchValue={this.state.SidebarModel.get("SearchText")}
                    />
                )}

                {this.state.ClickableTextCreateVisible && (
                    <ClickableTextEditor
                        context={this.state.ClickableTextContext}
                        onCloseCallback={() => this.CloseClickableTextCreateForm()}
                        editMode={this.state.ClickableTextEditMode}
                        tabName={this.state.ClickableTextTabName}
                        employeeId={this.state.employeeId}
                        IsInAdminMode={this.state.adminMode}
                        enumAdminMode={this.state.enumAdminMode}
                        isFromAnotherUser={this.state.isFromAnotherUser}
                        isGroupMode={this.state.isGroupMode}
                        employeeGroupId={this.state.employeeGroupId}
                        clickableContent={this.state.clickableContent}
                        isAdminCreateMode={this.state.isAdminCreateMode}
                        languageCode={this.state.languageCode}
                    />
                )}

                {this.state.DisplayExternalSearch && (
                    <ExternalSearchComponent
                        onSyncCallBack={this.state.DisplayExternalSearchCallBack}
                        onCancelCallback={() => this.closeExternalSearch()}
                        patientIdentifier={this.state.PatientIdentifier}
                        patientToUpdateContactid={this.state.ExternalSearchPatientContactId}
                        ExternalSearchSystems={cacheStore.ExternalSearchSystemsResponse}
                        DefaultExternalSearchSystemId={cacheStore.ExternalSearchSystemSitesResponse?.firstOrDefault(p => p.SiteId == this.state.ExternalSearchSiteId)?.Id}
                    />
                )}

                {this.state.DisplayApexExternalSearchPopup && (
                    <ApexExternalSearchPopup onCloseCallback={() => this.mutateState(s => s.DisplayApexExternalSearchPopup = false)} person={this.state.DisplayApexExternalSearchPopupPerson} />
                )}

                {this.state.DisplayDSQPatientPopup && (
                    <DSQPatientComponent onCloseCallback={() => this.closeDSQPatientPopup()} patientModel={this.state.PatientModelForDSQ} />
                )}

                {this.state.DisplayDSQActiveMedPopup && (
                    <DSQActiveMedGridComponent onCloseCallback={() => this.closeDSQActiveMedPopup()} patientContactId={this.state.PatientContactId} />
                )}

                {this.state.DisplayDSQLabsGridPopup && (
                    <DSQLabsGridComponent onCloseCallback={() => this.closeDSQLabsGridPopup()} patientContactId={this.state.PatientContactId} />
                )}

                {this.state.DisplayDSQImgsGridPopup && (
                    <DSQImgsGridComponent onCloseCallback={() => this.closeDSQImgsGridPopup()} patientContactId={this.state.PatientContactId} />
                )}

                {this.state.DSQEmployeePopup && // When this component is used in settings tab, we pass the info of the current user
                    (
                        <DSQEmployeeComponent
                            employeeModel={employee.Model}
                            onCloseCallback={() => this.closeDSQEmployeePopup()}
                            updateEmployeeCallback={(e: Employee) => this.updateCurrentEmployee(e)}
                        />
                    )
                }

                {this.state.DisplayDSQNipPopup && (
                    <DSQNipComponent onCloseCallback={() => this.closeDSQNipPopup()} />
                )}

                {this.state.DisplayAttachmentPopup && this.state.AttachmentPopupPatientPerson && (
                    <FileSelectionContainer
                        patient={this.state.AttachmentPopupPatientPerson}
                        title={cacheStore.GetString("AttachFilesLabel")}
                        type={FileSelectionContainerType.Attachment}
                        maxFilesAttachment={this.state.AttachmentPopupMaxFiles}
                        onClose={() => this.closeDisplayAttachmentPopup()}
                        onPrintOrAttachClicked={files => this.handleOnAttach(files)}
                        autoManageOverlay={true}
                    />
                )}

                {this.state.DisplayAttachmentPopup && this.state.AttachmentPopupPatientPerson == null && (
                    <Popup
                        title={cacheStore.GetString("PatientLabel")}
                        style={{ width: 560, height: "40%", top: "30%" }}
                        onCloseDelegate={() => this.mutateState(s => s.DisplayAttachmentPopup = false)}
                    >
                        <div className="flex-container" style={{ marginTop: "35px", marginLeft: "35px", marginRight: "35px", marginBottom: "35px" }}>
                            <PersonSearchAutocompleteCustom
                                allowMultipleItemSelection={false}
                                focusOnLoad={true}
                                disabled={false}
                                componentId="add_attachmentpopup_patients"
                                selectedItemList={null}
                                onSelectionCallback={p => {
                                    this.mutateState(s => s.AttachmentPopupPatientPerson = p.Item);
                                }}
                                defaultTextValue={this.state.AttachmentPopupPatientSearch}
                                growSearchWidthToParentNode
                            />
                        </div>
                    </Popup>
                )}

                {this.state.OpenAttachmentsPopup && (
                    <OpenAttachmentsPopup
                        onCloseCallback={() => this.close_OpenAttachmentPopup()}
                        Attachments={this.state.OpenAttachmentsPopupItems}
                        Xposition={this.state.OpenAttachmentsPopup_Xpos}
                        Yposition={this.state.OpenAttachmentsPopup_Ypos}
                    />
                )}

                {this.state.DisplaySessionExpiryWarning &&
                    <SessionTimeoutWarningPopup />
                }

                {this.state.displayFacturationNetCredentialsPopup && (
                    <FacturationNetCredentialsPopup
                        response={this.state.facturationNetResponse}
                        onCloseCallback={() => {
                            this.mutateState(s => s.displayFacturationNetCredentialsPopup = false);
                            sessionStore.hideGlobalOverlay();
                        }}
                    />
                )}

                {this.state.SendTaskOrMessagePopupModel?.get("IsPopupVisible") && (
                    <MessageTaskEditContainer
                        context={this.state.SendTaskOrMessagePopupModel.get("Context")}
                        isTask={this.state.SendTaskOrMessagePopupModel.get("IsTask")}
                        useOverlay
                        onResponseCallback={shouldReloadParent => {
                            this.handleMessageTaskResponseCallback(
                                shouldReloadParent
                            );
                        }}
                        onSaveOverride={this.state.SendTaskOrMessagePopupModel.get("OnSave")}
                        tempAttachedLabFillerID={this.state.SendTaskOrMessagePopupModel.get("TempAttachedLabFillerID")}
                        selectedPatients={this.state.SendTaskOrMessagePopupModel.get("SelectedPatients").toArray()}
                        encounterId={this.state.SendTaskOrMessagePopupModel.get("EncounterId")}
                        attachedObjects={this.state.SendTaskOrMessagePopupModel.get("TempAttachment")}
                        tempDocumentId={this.state.SendTaskOrMessagePopupModel.get("TempDocumentId")}
                        selectedClinicians={this.state.SendTaskOrMessagePopupModel.get("IsTask")
                            ? taskEditSelectedClinicians : messageEditSelectedClinicians
                        }
                    />
                )}

                {this.state.SendRecallPopupModel?.get("IsPopupVisible") &&
                    <SendRecallPopupControl ContainerId="doc_container" Model={this.state.SendRecallPopupModel} />
                }

                {this.state.isFaxPrintSignPopupOpen && (
                    <FaxSignPrintExportableFileComponent
                        exportableFile={this.state.faxPrintConfig.exportableFile}
                        attachedDocuments={this.state.faxPrintConfig.attachedDocuments}
                        preSignedFile={this.state.faxPrintConfig.preSignedCopy}
                        mode={this.state.faxPrintConfig.exportMode}
                        popupTitle={this.state.faxPrintConfig.popupTitle}
                        hideSignaturePinControl={this.state.faxPrintConfig.hideSignaturePinControl}
                        patientContactId={this.state.faxPrintConfig.patientContactId}
                        onClose={() => {
                            this.mutateState(s => {
                                s.isFaxPrintSignPopupOpen = false;
                                s.faxCoverSheetProps.CoverPageContent = null;
                                s.faxCoverSheetProps.CoverPageTitle = null;
                            });
                            this.state.faxPrintConfig.onClose?.();
                        }}
                        onApplyOverlaysCallback={() => this.state.faxPrintConfig.onApplyOverlaysCallback && this.state.faxPrintConfig.onApplyOverlaysCallback()}
                        onPrintButtonCallback={currentPreview => {
                            this.followupWithSyncToPortalIfRequired(currentPreview);
                            this.state.faxPrintConfig.onPrintButtonCallback?.();
                        }}
                        onFaxSuccessful={currentPreview => this.followupWithSyncToPortalIfRequired(currentPreview)}
                        onSyncToPortalCallback={(currentPreview, unsigned, signed) => this.state.faxPrintConfig.syncToPortalAfterAction(currentPreview, unsigned, signed)}
                        selectionPages={this.state.faxPrintConfig.selectionPages}
                        onSignButtonCallback={() => this.state.faxPrintConfig.onSignButtonCallback?.()}
                        isSyncToPortalAfterEnabled={this.state.faxPrintConfig.isSyncToPortalAfterEnabled}
                        syncToPortalAfterChecked={this.state.faxPrintConfig.syncToPortalAfterChecked}
                        onSyncToPortalChanged={isChecked => this.onSyncToPortalChanged(isChecked)}
                        defaultContext={this.state.faxPrintConfig.defaultContext}
                        disableSaveSignature={!this.state.faxPrintConfig.isSaveSignatureEnabled}
                        useSignedCopyOverride={cacheStore.ClinicSettings.EnableSignedAuthorization && this.state.faxPrintConfig.useSignedCopyOverride}
                        encounterId={this.state.faxPrintConfig.encounterId}
                        onFaxAsync={this.state.faxPrintConfig.onFaxAsync}
                        useLabsSearch={this.state.faxPrintConfig.useLabsSearch} // Temporary prop to allow overriding which table to search for. This will be removed when ContactDirectory project is merged.
                        hideInitialSignButton={this.state.faxPrintConfig.hideInitialSignButton}
                        handleFaxComplete={() => this.handleFaxComplete()}
                        fileType={this.state.faxPrintConfig.fileType}
                        selectedRecipient={this.state.faxPrintConfig.selectedRecipient}
                        onFaxCoverSheetChange={(faxCoverSheetUpdate: Partial<IFaxCoverSheetProps>) =>
                            this.mutateState(s => {
                                s.faxCoverSheetProps = {
                                    ...s.faxCoverSheetProps,
                                    ...faxCoverSheetUpdate
                                };
                            })
                        }
                        faxCoverSheet={this.state.faxCoverSheetProps}
                    />
                )}

                {cacheStore.ClinicSettings.EnableTelemedFeature
                    && !IsNullOrWhiteSpace(this.state.telemedApplicationUrl)
                    && (
                        <TelemedApplicationPopup
                            telemedUrl={this.state.telemedApplicationUrl}
                            onClose={() => this.mutateState(s => s.telemedApplicationUrl = null)}
                        />
                    )
                }

                {this.state.externalBillingAuthPopup.isOpen && (
                    <ExternalBillingCredentialsPopup
                        billingProvider={this.state.externalBillingAuthPopup.billingProvider}
                        externalBillingUser={this.state.externalBillingAuthPopup.billingUser}
                        onClose={() => this.onExternalBillingAuthPopupClose()}
                        onAuthSuccess={billingUser => this.state.externalBillingAuthPopup.onAuthSuccess?.(billingUser)}
                    />
                )}

                {this.state.externalBillingEmployeeSelectPopup.isOpen && (
                    <ExternalBillingEmployeeSelectPopup
                        encounterEmployeeIds={this.state.externalBillingEmployeeSelectPopup.encounterEmployeeIds ?? []}
                        otherEmployeeIds={this.state.externalBillingEmployeeSelectPopup.otherEmployeeIds ?? []}
                        primaryClinicians={this.state.externalBillingEmployeeSelectPopup.primaryClinicians ?? null}
                        onCancel={() => this.onExternalBillingEmployeeSelectPopupClose()}
                        onEmployeeSelect={employeeId => this.state.externalBillingEmployeeSelectPopup.onEmployeeSelect?.(employeeId)}
                    />
                )}

                {this.state.patientWarningsPopup?.isOpen && (
                    <PatientMissingInfoWarning
                        patientContactId={this.state.patientWarningsPopup.patientContactId}
                        warnings={this.state.patientWarningsPopup.warnings}
                        callback={dto => {
                            this.mutateState(
                                s => s.patientWarningsPopup.isOpen = false,
                                () => this.state.patientWarningsPopup.callback(dto)
                            );
                        }}
                    />
                )}

                {this.state.popups
                    && Object
                        .keys(this.state.popups)
                        ?.map(key => (
                            <div key={`mainpopups_${key}`}>
                                {this.state.popups[key]}
                            </div>
                        ))
                }

                {cacheStore.ClinicSettings.EnableQuickDocumentSigning && this.state.signatureOptionPopup.isOpen &&
                    (
                        <SignatureOptionPopup
                            employeeContactId={sessionStore.individualContactId}
                            userId={sessionStore.userId}
                            hasPinSet={sessionStore.hasPinSet}
                            loginPinFrequency={LoginPinFrequencyModel.fromResponseModel(employee.Model.LoginPinFrequency)}
                            isObstetricalFileEnabled={employee.isQuebecObstetricalFileEnabled() || employee.isOntarioObstetricalFileEnabled() || employee.isBritishColumbiaObstetricalFileEnabled()}
                            onSave={pin => this.state.signatureOptionPopup.onSaveSuccess?.(pin)}
                            onClose={() =>
                                this.setState({
                                    signatureOptionPopup: {
                                        isOpen: false,
                                        onSaveSuccess: () => null
                                    }
                                })
                            }
                        />
                    )
                }

                {this.state.TermsAndConditionsPopup.isOpen && (
                    <TermsAndConditionsPopup
                        serviceName={this.state.TermsAndConditionsPopup.serviceName}
                        onClose={() => this.onTermsAndConditionsPopupClose()}
                        onOk={() => this.state.TermsAndConditionsPopup.onOk()}
                    />
                )}
            </div>
        );
    }

    public onSyncToPortalChanged(isChecked: boolean): void {
        this.mutateState(s => s.faxPrintConfig.syncToPortalAfterChecked = isChecked);
    }

    public followupWithSyncToPortalIfRequired(currentPreview: ExportableFile): void {
        if (this.state.faxPrintConfig.syncToPortalAfterChecked)
            this.state.faxPrintConfig?.syncToPortalAfterAction?.(currentPreview);
    }

    public onUserInput(): void {
        sessionStore.updateActivity();
    }

    public onContainerClick(e: React.MouseEvent): void {
        e.stopPropagation();
        overlayStore.handleOverlayClick();

        const op = new LocalEvent(LocalOperations.Misc.MyleApp_Container_Click);
        op.AddItem("event", e);
        LocalEventDispatcher.dispatch(op);

        if (this.state.OpenAttachmentsPopup) {
            this.close_OpenAttachmentPopup();
        }
    }

    private togglePeopleDropdown(): void {
        const s = new MainState();
        s.PatientDropdownVisible = !s.PatientDropdownVisible;
        this.setState(s);
    }

    private toggleAside(e: React.MouseEvent): void {
        e.stopPropagation();
        sessionStore.dispatch(LocalOperations.Sidebar.ToggleSidebar);
    }

    private handleFaxComplete(): void {
        if (cacheStore.ClinicSettings.EnableFaxSendingIndicator && this.state.faxPrintConfig?.sentFaxItemId) {
            sessionStore.dispatch(LocalPatientOperations.MedicalNote.LoadSentFaxes, { SentFaxItemIds: [this.state.faxPrintConfig.sentFaxItemId] });
        }
    }

    public componentDidMount(): void {
        this.eventIds.navStoreId = navStore.AddChangeListener(this.navChangeLister, this, "nav-store");
        this.eventIds.sessionStoreId = sessionStore.AddChangeListener(this.sessionChangeListener, this, "session-store");
        this.eventIds.overlayStoreId = overlayStore.AddChangeListener(this.overlayChangeListener, this, "overlay-store");
        this.eventIds.cacheStoreId = cacheStore.AddChangeListener(this.cacheStoreListener, this, "cache-store");
        this.eventIds.globalcommStoreId = globalSendCommunicationStore.AddChangeListener(this.globalCommunicationsStoreListener, this, "globalCommunications-store");
        this.eventIds.sidebarStore = sidebarStore.AddChangeListener(this.sidebarStoreListener, this, "sidebar-store");
        this.eventIds.labsStore = labsStore.AddChangeListener(this.labsStoreListener, this, "labs-store");
        this.eventIds.ramqStore = ramqStore.AddChangeListener(() => { }, this, "ramq-store");
        this.eventIds.patientStore = patientStore.AddChangeListener(this.patientStoreListener, this, "patient-store");
        this.eventIds.portfolioStore = portfolioStore.AddChangeListener(this.portfolioStoreListener, this, "portfolio-store");
        this.eventIds.aiScribeStore = aiScribeStore.AddChangeListener(this.aiScribeStoreListener, this, "aiscribe-store");
        this.listenToDispatcher();

        labsStore.LoadSettings(sessionStore.activeMYLEMenuTab == MyleTabKey.Patients);
        this.RefreshCounters();

        this.unlistenRouteChange = RouterHistory.listen(listener => {
            const { pathname: currentPath } = listener.location;
            const isRootPathIncluded: boolean = rootPath?.length > 0;
            const currentPathDirectory: string = isRootPathIncluded ? currentPath.substring(currentPath.indexOf(rootPath) + rootPath.length + 1) : currentPath.slice(1);
            const firstSlashIndex: number = currentPathDirectory.indexOf("/");
            const currentRootPath: string = firstSlashIndex === -1 ? currentPathDirectory : currentPathDirectory.substring(0, firstSlashIndex);

            this.mutateState(s => {
                s.Tabs = s.Tabs.map(p => {
                    const currentTabDefaultPath = this.defaultTabs[p.key].replace(/\/.+/, "");
                    if (currentRootPath === currentTabDefaultPath) {
                        cacheStore.UpdateTabsPath(p.key, currentPathDirectory);

                        return new MyleMenuTabItem({
                            ...p,
                            path: currentPathDirectory
                        });
                    }
                    else {
                        return p;
                    }
                });
            }, () => cacheStore.EmitChangeToListeners());
        });
    }

    public RefreshCounters(): void {
        if (sessionStore.hasPermission(EnumMyleLoginPermission.DocumentTabPermission)) {
            documentsStore.DocumentActions.setUnmanagedDocumentCount(documentsStore.DocumentsModel);
        }

        if (sessionStore.hasPermission(EnumMyleLoginPermission.CommunicationsTabPermission))
            communicationsStore.communicationActions.LoadCommunicationsCounts(sessionStore.individualContactId, 500);

        if (sessionStore.hasPermission(EnumMyleLoginPermission.LabsTabPermission)) {
            labsStore.LabActions.GetNewLabsCount();
            labsStore.LabActions.GetLabsActionsCount();
        }

        if (sessionStore.hasPermission(EnumMyleLoginPermission.PortfolioTabPermission))
            portfolioStore.PortfolioActions.LoadPortfolioCount();

        if (sessionStore.hasPermission(EnumMyleLoginPermission.PrescriptionRenewalTabPermission))
            fetchPrescriptionsRenewalCounters();
    }

    private DisplayExternalSearchFromPatientFile(identifier: string, patientContactId: string, siteId: Guid, callback: () => void): void {
        var s = new MainState();
        s.PatientIdentifier = identifier;
        s.ExternalSearchPatientContactId = patientContactId;
        s.ExternalSearchSiteId = siteId ?? sessionStore.getCurrentEmployee().getActiveSite()?.Model.Id;
        s.DisplayExternalSearch = true;
        s.DisplayExternalSearchCallBack = callback;
        this.setState(s);
    }

    private DisplayClickableTextCreateForm(context: string, tabName: string, isEdit: boolean, employeeId?: string, adminMode?: boolean, enumAdminMode?: number, isFromAnotherUser?: boolean, employeeGroupId?: string, isGroupMod?: boolean, isAdminCreate?: boolean, clickableTextContent?: string, languageCode?: string): void {
        var s = new MainState();
        s.ClickableTextCreateVisible = true;
        s.ClickableTextEditMode = isEdit;
        s.ClickableTextContext = context;
        s.ClickableTextTabName = tabName;
        s.employeeId = employeeId;
        s.adminMode = adminMode;
        s.enumAdminMode = enumAdminMode;
        s.isFromAnotherUser = isFromAnotherUser;
        s.employeeGroupId = employeeGroupId;
        s.isGroupMode = isGroupMod;
        s.clickableContent = clickableTextContent;
        s.isAdminCreateMode = isAdminCreate;
        s.languageCode = languageCode;

        this.setState(s);
    }

    private CloseClickableTextCreateForm(): void {
        var s = new MainState();
        s.ClickableTextCreateVisible = false;
        this.setState(s);

        window.setTimeout(() => {
            let op = new LocalEvent(LocalOperations.MainComponentViewOperations.EditorClosed);
            MainComponentStateDispatcher.dispatch(op);
        }, 50);
    }

    private closeOpenPatientDropdownIfOpen(): void {
        if (this.state.PatientDropdownVisible) {
            var s = new MainState();
            s.PatientDropdownVisible = false;
            this.setState(s);
        }

        ClickDispatcher.dispatch(0); // dispatch nothing
    }

    private onPersonFileSelection(): void {
        this.setState({ PatientDropdownVisible: false });
    }

    public cacheStoreListener(): void {
        var s = new MainState();
        s.Tabs = cacheStore.Tabs;
        this.setState(s);
    }

    public patientStoreListener(): void {
        this.setState({
            IsPatientStoreLoadingStuff: patientStore.IsLoading
        });
    }

    public portfolioStoreListener(): void {
        var s = new MainState();
        s.ApssInboxModel = portfolioStore.apssInboxModel;
        this.setState(s);
    }

    public aiScribeStoreListener(): void {
        let s = new MainState();
        s.aiScribeContainerModel = aiScribeStore.Model;
        this.setState(s);
    }

    public globalCommunicationsStoreListener(): void {
        var s = new MainState();
        s.SendTaskOrMessagePopupModel = globalSendCommunicationStore.SendTaskOrMessageModel;
        s.SendRecallPopupModel = globalSendCommunicationStore.SendRecallPopupModel;
        this.setState(s);
    }

    public sidebarStoreListener(): void {
        var s = new MainState();
        s.SidebarModel = sidebarStore.Model;
        this.setState(s);
    }

    public labsStoreListener(): void {
        var s = new MainState();
        s.LabsTabModel = labsStore.Model;
        this.setState(s);
    }

    public sessionChangeListener(): void {
        var s = new MainState();
        s.LoginModel = sessionStore.clientLoginModel;
        this.setState(s);
    }

    public overlayChangeListener(): void {
        var s = new MainState();
        s.hasOverlay = overlayStore.hasOverlay();
        s.overlaysHaveBackground = overlayStore.overlaysHaveBackground();
        s.overlaysHaveZIndexAbovePopup = overlayStore.overlaysHaveZIndexAbovePopup();
        this.setState(s);
    }

    public navChangeLister(): void {
        var s = new MainState();
        this.setState(s);
    }

    public openSyncModal(patient: Person): void {
        var s = new MainState();
        s.DisplayPortalSyncModal = true;
        s.SelectedPortalPatient = patient;
        this.setState(s);
        sessionStore.showGlobalOverlay(true);
    }

    public closeSyncModal(): void {
        var s = new MainState();
        s.DisplayPortalSyncModal = false;
        s.SelectedPortalPatient = null;
        this.setState(s);
        sessionStore.hideGlobalOverlay();
    }

    public closeExternalSearch(): void {
        var s = new MainState();
        s.DisplayExternalSearch = false;
        s.DisplayExternalSearchCallBack = null;
        this.setState(s);
    }

    public openDSQNipPopup(action: () => void): void {
        var s = new MainState();
        s.DisplayDSQNipPopup = true;
        s.DSQFunction = action;
        this.setState(s);
    }

    public closeDSQNipPopup(): void {
        let self = this;
        let then = self.state.DSQFunction;

        var s = new MainState();
        s.DisplayDSQNipPopup = false;
        s.DSQFunction = null;

        this.setState(s, then);
    }

    public openDSQPatientPopup(): void {
        var s = new MainState();
        s.DisplayDSQPatientPopup = true;
        this.setState(s);
    }

    public closeDSQPatientPopup(): void {
        var s = new MainState();
        s.DisplayDSQPatientPopup = false;
        this.setState(s);
    }

    public openDSQActiveMedPopup(patientContactId: string): void {
        var s = new MainState();
        s.DisplayDSQActiveMedPopup = true;
        s.PatientContactId = patientContactId;
        this.setState(s);
    }

    public closeDSQActiveMedPopup(): void {
        var s = new MainState();
        s.DisplayDSQActiveMedPopup = false;
        this.setState(s);
    }

    public openDSQLabsGridPopup(patientContactId: string): void {
        var s = new MainState();
        s.DisplayDSQLabsGridPopup = true;
        s.PatientContactId = patientContactId;
        this.setState(s);
    }

    public closeDSQLabsGridPopup(): void {
        var s = new MainState();
        s.DisplayDSQLabsGridPopup = false;
        this.setState(s);
    }

    public openDSQImgsGridPopup(patientContactId: string): void {
        var s = new MainState();
        s.DisplayDSQImgsGridPopup = true;
        s.PatientContactId = patientContactId;
        this.setState(s);
    }

    public closeDSQImgsGridPopup(): void {
        var s = new MainState();
        s.DisplayDSQImgsGridPopup = false;
        this.setState(s);
    }

    public openDisplayAttachmentPopup(
        AttachmentPopupPatientPerson: Person,
        AttachmentPopupPatientSearch: string,
        AttachmentPopupResponseCallback: (attachments: ExportableFile[]) => void,
        AttachmentPopupMaxFiles: number,
        Model: IAPSSInboxModel
    ): void {
        const s = new MainState();
        s.DisplayAttachmentPopup = true;
        s.AttachmentPopupPatientPerson = AttachmentPopupPatientPerson;
        s.AttachmentPopupPatientSearch = AttachmentPopupPatientSearch;
        s.AttachmentPopupResponseCallback = AttachmentPopupResponseCallback;
        s.AttachmentPopupMaxFiles = AttachmentPopupMaxFiles;
        s.ApssInboxModel = Model;

        this.setState(s);
    }

    public closeDisplayAttachmentPopup(): void {
        var s = new MainState();
        s.DisplayAttachmentPopup = false;
        this.setState(s);
    }

    public open_OpenAttachmentPopup(openAttachmentsPopupItems: OpenAttachmentsPopupItem[], Xpos: number, Ypos: number): void {
        sessionStore.showGlobalOverlay(false);

        var s = new MainState();
        s.OpenAttachmentsPopup = true;
        s.OpenAttachmentsPopupItems = openAttachmentsPopupItems;
        s.OpenAttachmentsPopup_Xpos = Xpos;
        s.OpenAttachmentsPopup_Ypos = Ypos;
        this.setState(s);
    }

    public close_OpenAttachmentPopup(): void {
        sessionStore.hideGlobalOverlay();

        var s = new MainState();
        s.OpenAttachmentsPopup = false;
        s.OpenAttachmentsPopupItems = [];
        s.OpenAttachmentsPopup_Xpos = 0;
        s.OpenAttachmentsPopup_Ypos = 0;
        this.setState(s);
    }

    public openDSQEmployeePopup(): void {
        var s = new MainState();
        s.DSQEmployeePopup = true;
        this.setState(s);
    }

    public closeDSQEmployeePopup(): void {
        var s = new MainState();
        s.DSQEmployeePopup = false;
        this.setState(s);
    }

    private setPopupModel(model: PopupModel): void {
        this.mutateState(p => p.CommonPopupModel = model);
    }

    private updateCurrentEmployee(employee: Employee): void {
        let self = this;

        sessionStore.updateCurrentEmployee((e: Employee) => {
            e.FirstNameDSQ = employee.FirstNameDSQ;
            e.LastNameDSQ = employee.LastNameDSQ;
            e.LicenceDSQ = employee.LicenceDSQ;
            e.LicenceRoot = employee.LicenceRoot;
            e.NUI = employee.NUI;
        });

        self.mutateState(s => s.DSQEmployeePopup = false);

        settingsStore.EmitChangeToListeners();
    }

    private handleOnAttach(checkedFiles: ExportableFile[]): void {
        this.state.AttachmentPopupResponseCallback && this.state.AttachmentPopupResponseCallback(checkedFiles);
        this.closeDisplayAttachmentPopup();
    }

    private handleMessageTaskResponseCallback(shouldReloadParent: boolean): void {
        if (shouldReloadParent) {
            switch (this.state.SendTaskOrMessagePopupModel?.get("Context")) {
                case MessageOrTaskContext.Documents:
                    if (this.state.SendTaskOrMessagePopupModel.get("FromCreateView"))
                        sessionStore.dispatch(
                            LocalOperations.Documents.View_LoadAttachedTasks,
                            {
                                documentId: this.state.SendTaskOrMessagePopupModel.get("TempDocumentId")
                            }
                        );
                    else
                        sessionStore.dispatch(LocalOperations.Documents.SearchSettings_OnRefreshClick);
                    break;
                case MessageOrTaskContext.Labs:
                    sessionStore.dispatch(
                        LocalOperations.LabsUI.LoadLabTaskStatus,
                        { labFillerId: this.state.SendTaskOrMessagePopupModel.get("TempAttachedLabFillerID") }
                    );
                    break;
                case MessageOrTaskContext.Encounter:
                    sessionStore.dispatch(
                        LocalPatientOperations.MedicalNote.LoadAttachedCommunications,
                        {
                            encounterId: this.state.SendTaskOrMessagePopupModel.get("EncounterId")
                        }
                    );
                    break;
            }
        }

        sessionStore.dispatch(LocalOperations.SendTaskOrMessageModel.Cancel_Add);
    }

    private onExternalBillingAuthPopupClose(): void {
        this.mutateState(s => s.externalBillingAuthPopup = {
            isOpen: false,
            billingProvider: BillingProvider.ClinicDefault
        });
    }

    private onExternalBillingEmployeeSelectPopupClose(): void {
        this.mutateState(s => s.externalBillingEmployeeSelectPopup = {
            isOpen: false
        });
    }

    private onTermsAndConditionsPopupClose(): void {
        this.mutateState(s => s.TermsAndConditionsPopup = {
            isOpen: false
        });
    }

    private listenToDispatcher(): void {
        var self = this;
        this.localDispatcherReferenceId = MainComponentStateDispatcher.register((response: LocalEvent) => {
            switch (response.Operation) {
                case LocalOperations.MainComponentViewOperations.DisplayCreateClickableText:
                    let context = response.Get<string>("context");
                    let isEdit = response.Get<boolean>("isEdit");
                    let tabName = response.Get<string>("tabName");
                    if (!tabName) { tabName = ""; }
                    let employeeId = response.Get<string>("employeeId");
                    let adminMode = response.Get<boolean>("adminMode");
                    if (isEdit == null) { isEdit = false; }
                    if (adminMode == null) { adminMode = false; }
                    let enumAdminMode = response.Get<number>("enumAdminMode");
                    let isFromAnotherUser = response.Get<boolean>("isFromAnotherUser");
                    let employeeGroupId = response.Get<string>("employeeGroupId");
                    let isGroupMode = response.Get<boolean>("isGroupMode");
                    if (isGroupMode == null) { isGroupMode = false; }
                    let clickableContent = response.Get<string>("clickableContent");
                    let isAdminCreateMode = response.Get<boolean>("isAdminCreateMode");
                    let languageCode = response.Get<string>("languageCode");

                    self.DisplayClickableTextCreateForm(context, tabName, isEdit, employeeId, adminMode, enumAdminMode, isFromAnotherUser, employeeGroupId, isGroupMode, isAdminCreateMode, clickableContent, languageCode);
                    break;

                case LocalOperations.MainComponentViewOperations.DisplaySyncModal:
                    let client = response.Get<Person>("client");
                    self.openSyncModal(client);
                    break;

                case LocalOperations.MainComponentViewOperations.HideSyncModal:
                    self.closeSyncModal();
                    break;

                case LocalOperations.MainComponentViewOperations.RefreshTabs:
                    this.CloseClickableTextCreateForm();
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayExternalSearch:
                    let identifier = response.Get<string>("identifier");
                    let patientContactId = response.Get<string>("patientContactId");
                    let siteId = response.Get<Guid>("siteId");
                    let callback = response.Get<() => void>("callback");
                    this.DisplayExternalSearchFromPatientFile(identifier, patientContactId, siteId, callback);
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayApexExternalSearchPopup:
                    let person = response.Get<Person>("patient");
                    this.mutateState(s => {
                        s.DisplayApexExternalSearchPopup = true;
                        s.DisplayApexExternalSearchPopupPerson = person;
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayDSQPopup:
                    let patientModel = response.Get<Patient>("model");

                    var s = new MainState();
                    s.PatientModelForDSQ = patientModel;
                    this.setState(s, () => {
                        self.openDSQPatientPopup();
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayDSQNip:
                    this.openDSQNipPopup(response.Get<() => void>("action"));
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayDSQActiveMedPopup:
                    var s = new MainState();
                    s.PatientContactId = response.Get<string>("patientContactId");
                    this.setState(s, () => {
                        this.openDSQActiveMedPopup(s.PatientContactId);
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayDSQLabsGridPopup:
                    var s = new MainState();
                    s.PatientContactId = response.Get<string>("patientContactId");
                    this.setState(s, () => { this.openDSQLabsGridPopup(s.PatientContactId); });
                    break;

                case LocalOperations.MainComponentViewOperations.ShowVisitTypeSelectionPopup:
                    this.mutateState(s => {
                        s.showVisitTypeSelectionPopup = true;
                        s.visitTypeSelectionPopupCallback = response.Get<() => void>("callback");
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayAttachmentPopup:
                    var AttachmentPopupPatientPerson = response.Get<Person>("AttachmentPopupPatientPerson");
                    var AttachmentPopupPatientSearch = response.Get<string>("AttachmentPopupPatientSearch");
                    var AttachmentPopupResponseCallback = response.Get<(attachments: ExportableFile[]) => void>("AttachmentPopupResponseCallback");
                    var AttachmentPopupMaxFiles = response.Get<number>("AttachmentPopupMaxFiles");

                    var Model = response.Get<IAPSSInboxModel>("Model");
                    self.openDisplayAttachmentPopup(AttachmentPopupPatientPerson, AttachmentPopupPatientSearch, AttachmentPopupResponseCallback, AttachmentPopupMaxFiles, Model);
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayOpenAttachmentPopup:
                    var Attachments = response.Get<OpenAttachmentsPopupItem[]>("Attachments");
                    var Xpos = response.Get<number>("Xpos");
                    var Ypos = response.Get<number>("Ypos");
                    self.open_OpenAttachmentPopup(Attachments, Xpos, Ypos);
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayDSQImgsGridPopup:
                    var s = new MainState();
                    s.PatientContactId = response.Get<string>("patientContactId");
                    self.setState(s, () => { this.openDSQImgsGridPopup(s.PatientContactId); });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayDSQEmployeePopup:
                    this.openDSQEmployeePopup();
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayCommonPopup:
                    let model = response.Get<PopupModel>("model");
                    this.setPopupModel(model);
                    break;

                case LocalOperations.MainComponentViewOperations.HideCommonPopup:
                    this.setPopupModel(null);
                    break;

                case LocalOperations.MainComponentViewOperations.DisplaySessionWarningPopup:

                    var s = new MainState();
                    s.DisplaySessionExpiryWarning = !this.state.DisplaySessionExpiryWarning;

                    // backend session check when click on OK
                    if (!s.DisplaySessionExpiryWarning) {
                        sessionStore.updateActivity();
                        sessionStore.action.checkSession();
                    }

                    this.setState(s);
                    break;

                case LocalOperations.MainComponentViewOperations.RefreshCounters:
                    this.RefreshCounters();
                    break;

                case LocalOperations.Misc.MyleApp_Container_Click:
                    if (this.state.DisplayPortalSyncModal)
                        this.closeSyncModal();
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayFacturationNetUsernamePasswordPopup:
                    let facturationNetResponse = response.Get<ServerEvent>("response");
                    this.mutateState(s => {
                        s.displayFacturationNetCredentialsPopup = true;
                        s.facturationNetResponse = facturationNetResponse;
                    });
                    sessionStore.showGlobalOverlay(true);
                    break;

                case LocalOperations.MainComponentViewOperations.FaxPrintExportableFile:
                    this.mutateState(s => {
                        s.isFaxPrintSignPopupOpen = true;
                        s.faxPrintConfig = response.Get<IFaxPrintExportableFileConfig>("config");
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.ChangeTelemedPopupUrl:
                    this.mutateState(s => {
                        s.telemedApplicationUrl = response.Get<string>("roomUrl");
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayExternalBillingAuthentication:
                    const billingProvider = response.Get<BillingProvider>("billingProvider");
                    const billingUser = response.Get<ExternalBillingUserInfoDto>("billingUser");
                    const onAuthSuccess = response.Get<(billingUser: ExternalBillingUserInfoDto) => void>("onExternalBillingAuth");

                    this.mutateState(s => {
                        s.externalBillingAuthPopup = {
                            isOpen: true,
                            billingProvider: billingProvider,
                            billingUser: billingUser,
                            onAuthSuccess: onAuthSuccess
                        };
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayExternalBillingEmployeeSelect:
                    this.mutateState(s => {
                        s.externalBillingEmployeeSelectPopup = {
                            isOpen: true,
                            encounterEmployeeIds: response.Get<string[]>("encounterEmployeeIds"),
                            otherEmployeeIds: response.Get<string[]>("otherEmployeeIds"),
                            primaryClinicians: response.Get<string[]>("primaryClinicians"),
                            onEmployeeSelect: response.Get<(employeeId: string) => void>("onEmployeeSelect")
                        };
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayPatientWarnings:
                    this.mutateState(s => {
                        s.patientWarningsPopup = {
                            patientContactId: response.Get<string>("patientContactId"),
                            isOpen: true,
                            warnings: response.Get<PossiblePatientWarning[]>("warnings"),
                            callback: response.Get<(dto: PatientPossibleWarningDto) => void>("callback")
                        };
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplaySignatureOptionPopup:
                    this.setState({
                        signatureOptionPopup: {
                            isOpen: true,
                            onSaveSuccess: response.Get<(pin: string) => void | undefined>("onSaveSuccess")
                        }
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayAdditionalSignOffInformationPopup:
                    this.mutateState(s => {
                        s.popups["additionalSignOffInfo"] = response.Get<JSX.Element>("props");
                    });
                    break;

                case LocalOperations.MainComponentViewOperations.DisplayTermsAndConditionsPopup:
                    this.mutateState(s => {
                        s.TermsAndConditionsPopup = {
                            isOpen: true,
                            serviceName: response.Get<TermsAndConditionsServiceNames>("serviceName"),
                            onOk: response.Get<() => void>("onOk")
                        };
                    });
                    break;
            }
        });
    }
}

export { Main };
